export default {
	company:'北京正楚科技有限公司',
	companyAbbr:'正楚科技',
	companyDesc:'一站式现代信息化建设解决方案供应商',
	companyBuildYear:'2021',
	companyUrl:'https://www.zhengchukj.com',
	companyEmail:'bd&#64;zhengchukj.com',
	
	policeRegisteCode:'京公网安备11011102002598号',
	webRegisteCode:'京ICP备2024093504号',

	logo:'/static/img/logo/zc.svg',
	logoAnimate:'/static/img/logo/zc.svg',

	invoice:[
		'公司名称：北京正楚科技有限公司',
		'税号：91110111MA7DKPDH06',
		'公司地址：北京市房山区城关街道顾八路1区1号-B894',
		'开户行：中国工商银行北京燕山支行',
		'联行号：102100000169',
		'账户：0200001609200343306',
		'电子邮箱：bd&#64;zhengchukj.com'
	].join("\n"),
}